<template>
    <div>
        <div class="catalog-map__placeholder"></div>
        <div class="catalog-map yamap" ref="catalogMap">
            <transition name="fade" duration="450" tag="div">
                <div class="catalog-layout__content_empty" v-if="placemarksData.list.length == 0 & map != null">
                    <p>Нет результатов</p>
                </div>
            </transition>           
        </div>
    </div> 
</template>

<script>
    const API_KEY = "2dcff47b-ec9d-4d92-8b55-cd57fe2e0929";   
    const GEO_REGEXP = /^(\s*)([-+]?)([\d]{1,2})(((\.)(\d+)(\s*)(,)))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)(\s*)$/;

    class MapIcon {
        constructor(href, size, offset) {
            this.href = href;
            this.size = size;
            this.offset = offset;
        }
    }

    export default {
        props: {
            parent: {
                type: [Number, String],
                required: true
            },
            placemarksData: {
                type: Object,
                default: {
                    list: [],
                    isLoading: false
                }
            },
            filters: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                map: null,
                clusterer: null,
                balloonContentLayout: null
            }
        },
        computed: {
            placemarks() {
                const markerInner = new MapIcon("/images/marker-inner.png", [26, 26], [-13, -13]);
                let _placemarks = this.placemarksData.list.filter(pm => GEO_REGEXP.test(pm.location.join()));
                return _placemarks.map((item) => {
                        return new ymaps.Placemark(item.location, item, {
                            iconLayout: 'default#image',
                            iconImageHref: markerInner.href,
                            iconImageSize: markerInner.size,
                            iconImageOffset: markerInner.offset,
                            balloonContentLayout: this.balloonContentLayout,
                            balloonPanelMaxMapArea: 0
                        });
                    });
            }
        },
        methods: {
            onMapsReady() {
                // Init yandex map object
                this.map = new ymaps.Map(this.$refs.catalogMap, {
                    center: [59.934844, 30.330495], // Saint-Petersburg downtown
                    zoom: 13,
                    controls: ['zoomControl', 'fullscreenControl']
                });

                this.map.behaviors.disable('scrollZoom');

                // Create balloon template
                const balloonTemplate =
                    `<a href="{{properties.url}}" class="catalog-map__infowindow">
                        <div class="img"> 
                            <img src="{{properties.thumbnail}}" alt="">
                            <span class="metro"><i style="background-color: {{properties.metro.color}};"></i>{{properties.metro.title}}</span>
                        </div>
                        <span class="title">{{properties.title}}</span>
                        <span class="price">от {{properties.meterPrice}} /м<sup>2</sup></span>
                    </a>`;

                // Create balloon class from template
                this.balloonContentLayout = ymaps.templateLayoutFactory.createClass(balloonTemplate);
                              
                const markerOuter = new MapIcon("/images/marker-outer.png", [38, 38], [-19, -19]);
                this.clusterer = new ymaps.Clusterer({
                    clusterIcons: [markerOuter],
                    clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('<div style="color: #FFFFFF;" class="mapMarker">$[properties.iconContent]</div>')
                });

                this.$emit("maps-opened");
            },
            initMarkers() {
                this.clusterer.removeAll();
                if (this.placemarks && this.placemarks.length > 0) {
                    this.clusterer.add(this.placemarks);
                    this.map.geoObjects.add(this.clusterer);
                    this.map.setBounds(this.clusterer.getBounds(), {
                        checkZoomRange: true
                    });
                }
                else {
                    this.map.setCenter([59.934844, 30.330495], 13); // to default state
                }
            }
        },
        watch: {
            placemarks() {
                this.initMarkers();
            }
        },
        created() {
            this.$on("maps-ready", this.onMapsReady);
            ymaps.ready(() => {
                this.$emit("maps-ready");              
            });
        }
    }
</script>